import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api";

const rateClass = (r) => (r === null ? "" : r < 50 ? "low" : r < 75 ? "mid" : "high");

const QuestionInsight = ({ q, i }) => (
  <div className="insight-q" data-testid={`insight-question-${i + 1}`}>
    <div className={`insight-rate ${rateClass(q.correct_rate)}`} data-testid={`insight-rate-${i + 1}`}>{q.correct_rate === null ? "—" : `${q.correct_rate}%`}<small>correct</small></div>
    <div className="insight-body"><b>{q.prompt}</b>
      <ul>{q.options.map((o, j) => {
        const pct = q.seen ? Math.round((100 * q.option_counts[j]) / q.seen) : 0;
        return <li key={j} className={j === q.answer ? "correct" : j === q.top_wrong_option ? "trap" : ""}>
          <span className="bar" style={{ width: `${pct}%` }} /><span className="label">{String.fromCharCode(65 + j)}. {o}</span><span className="pct">{pct}%</span>
        </li>;
      })}</ul>
      {q.top_wrong_option !== null && <p className="muted small" data-testid={`insight-trap-${i + 1}`}>Most common wrong answer: <b>{String.fromCharCode(65 + q.top_wrong_option)}</b>. Consider clarifying this topic in your course content.</p>}
      {q.skipped > 0 && <p className="muted small">{q.skipped} learner(s) skipped this question.</p>}
    </div>
  </div>
);

export const InsightsAdmin = ({ certs }) => {
  const [certId, setCertId] = useState("");
  const [data, setData] = useState(null);
  const active = certId || certs[0]?.id || "";
  useEffect(() => {
    if (!active) return;
    setData(null);
    api.get(`/admin/certifications/${active}/insights`).then((r) => setData(r.data)).catch((e) => toast.error(formatError(e)));
  }, [active]);
  return (
    <div>
      <div className="section-title"><h2>Results insights</h2>
        <select data-testid="insights-cert-select" value={active} onChange={(e) => setCertId(e.target.value)}>{certs.map((c) => <option key={c.id} value={c.id}>{c.title}</option>)}</select></div>
      {!data ? <div className="loading">Loading insights…</div> : <>
        <div className="admin-stats insight-stats">
          <div className="admin-stat" data-testid="insight-attempts"><strong>{data.attempts}</strong><span>Attempts</span></div>
          <div className="admin-stat" data-testid="insight-pass-rate"><strong>{data.pass_rate ?? "—"}{data.pass_rate !== null && "%"}</strong><span>Pass rate</span></div>
          <div className="admin-stat" data-testid="insight-average"><strong>{data.average_score ?? "—"}{data.average_score !== null && "%"}</strong><span>Average score</span></div>
          <div className="admin-stat" data-testid="insight-timed-out"><strong>{data.timed_out}</strong><span>Timed out</span></div>
        </div>
        <div className="score-dist" data-testid="insight-score-distribution">{data.score_buckets.map((b) => {
          const max = Math.max(1, ...data.score_buckets.map((x) => x.count));
          return <div key={b.range}><span className="col" style={{ height: `${(b.count / max) * 100}%` }} /><b>{b.count}</b><small>{b.range}</small></div>;
        })}</div>
        <p className="muted small">Questions sorted from hardest to easiest. Answer details are tracked from {data.detailed_attempts} attempt(s); older attempts only count towards the totals.</p>
        {!data.questions.length && <div className="empty-state">No questions yet.</div>}
        <div className="question-admin-list">{data.questions.map((q, i) => <QuestionInsight key={q.id} q={q} i={i} />)}</div>
      </>}
    </div>
  );
};
